import {Inject, Injectable, NgZone} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {isNull, isUndefined} from 'util';
import {from, Observable, ReplaySubject, Subject, Subscription, throttleTime, timeout} from 'rxjs';

import {filter, first} from 'rxjs/operators';
import {IMessage, WebsocketService} from '../../services/websocket';
import {AllService} from '../../services/all.service';
import {
  Avatar,
  Chat,
  Contact, EditProfile,
  IMessengerConnector,
  Message,
  Profile, ResultChatDetail,
  ResultHistory, SendMessage,
} from '../../types/all.type';
import {NotifierWrapService} from '../../services/notifier-wrap.service';
import {log} from '../../functions';
import {environment} from '../../../environments/environment';
import {InterfaceService} from '../../services/interface.service';
import Bugsnag from '@bugsnag/js';
import {DcService} from '../../services/dc.service';
import {SnotifyPosition} from 'ng-snotify';

@Injectable()
export class TelegramService implements IMessengerConnector {
  public nemuAccounts: IMessengerConnector[] = [];
  public disabledMessageTextarea = false;
  public excludeDomains = [];
  public loadHistoryError: boolean | any = false;
  public type = 'telegram';
  public name = 'Telegram';
  public token: string;
  public unreadCount = 0;
  public lastNotify: string;

  public environment = environment;
  public urlApi: any = environment.tg;
  public urlApiFileUpload: string = environment.tg + '/api/file';
  public _openChat: Chat;
  public _openChatId: number | string;
  public arTyping: any = [];
  public arProfile: Profile = {} as Profile;
  public getProfile$: ReplaySubject<Profile> = new ReplaySubject();
  public setLocalHistory$: ReplaySubject<{
    id: string | number, arHistory: Message[]
  }> = new ReplaySubject();
  public arHistory: Message[] = [];

  public arLocalHistory: any = {};
  public replyMessage: Message | false = false;
  public forwardMessage: Message | false = false;
  public editMessage: Message | false = false;
  public messageLastDate: number;
  public bufferMessage = '';
  public message = '';

  public isLoadedProfile = false;
  public isLoadedProfileError = false;
  public reloadRequestsSubscription: Subscription;
  public httpOptions: any = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  public httpOptionsMulti: { headers: HttpHeaders } = {
    headers: new HttpHeaders({
      // 'Content-Type':  'multipart/form-data',
    })
  };
  public arFiles: any = {};
  public arVisibleStickers: any = [];
  public isDeleteAllMessage = false;

  constructor(
    private dcService: DcService,
    @Inject('instanceAll') public wsService: WebsocketService,
    public interfaceService: InterfaceService,
    public notifierWrapService: NotifierWrapService,
    private ngZone: NgZone,
    private allService: AllService,
    private http: HttpClient
  ) {
    this.urlApiFileUpload = environment.tg + '/api/file/';
    this.allService.wsService.on<IMessage>('error').subscribe((data) => {
      this.notifierWrapService.notify('error', data.error, SnotifyPosition.centerTop, 30000);
    });
    this.allService.wsService.on<IMessage>('typing').subscribe((data) => {
      if (this.openChat?.type) {
        if (this.openChat.type === 'private' || this.openChat.type === 'bot') {
          this.arTyping.push(this.openChat);
          setTimeout(() => this.arTyping.splice(this.arTyping.length - 1, 1), 5000);
        } else {
          from(this.openChat.members)
            .pipe(filter((v: any) => v.chat_id === data.user_id))
            .subscribe((member: any) => {
              this.arTyping.push(member);
              setTimeout(() => this.arTyping.splice(this.arTyping.length - 1, 1), 5000);
            });
        }
        this.dcService.detectChanges$.next('chat-show');
      }
    });
    setTimeout(() => {
      this.setToken();
      this.arLocalHistory = (this.getVarLocal('history', {}) as Chat[]);
      if (this.isAuth) {
        this.loadProfile('init');
      }
    }, 1);
    this.reloadRequestsSubscription = this.allService.wsService.reloadRequests$.subscribe((val) => {
      this.isLoadedProfileError && this.loadProfile();
    });
    this.setLocalHistory$.pipe(throttleTime(10000)).subscribe((data) => {
      // this.setLocalHistory(data.id, data.arHistory);
    });
  }

  get status(): boolean {
    return !this.allService.wsService.disconnect;
  }

  getUploadUrl(chatId, type = 'audio_message'): Observable<{ uploadUrl: string, method: 'post' | 'put' }> {
    return new Observable((observer) => {
      observer.next({uploadUrl: this.urlApiFileUpload, method: 'post'});
      observer.complete();
    });
  }

  addedFile(file: File): Observable<{ uploadUrl: string }> {
    return new Observable((observer) => {
      observer.next({uploadUrl: this.urlApiFileUpload});
      observer.complete();
    });
  }

  saveFile(file: File | Blob, title = '') {
    return new Observable((observer) => {
      observer.next(file[0]);
      observer.complete();
    }).pipe(first()); // , tag("saveFile")
  }

  get isAuth(): boolean {
    return !isNull(localStorage.getItem(`auth_${this.type}`));
  }

  logout(onlyToken = true): void {
    console.warn('TG logout', this.type);
  }

  setToken(token = ''): void {
    if (token.length > 0) {
      this.token = token;
      localStorage.setItem(`${this.type}_token`, this.token);
    }else{
      this.token = localStorage.getItem(`${this.type}_token`);
      if (!this.token && this.type.indexOf('|') === -1) {
        // Если основной сервис, то берем токен основной
        this.token = this.allService.token;
      } else if (!this.token) {
        this.token = this.allService.generateToken();
        localStorage.setItem(`${this.type}_token`, this.token);
      }
    }
    this.initToken();
  }
  initToken(): void {
    this.allService.setCookie(`${this.type}_token`, this.token, {expires: 99999999});
    if (this.token) {
      this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Token ' + this.token);
      this.httpOptionsMulti.headers = this.httpOptionsMulti.headers.set('Authorization', 'Token ' + this.token);
    }
  }
  resetToken(): void {
    this.token = this.allService.generateToken();
    localStorage.setItem(`${this.type}_token`, this.token);
    this.setToken();
  }

  public setAuth(): void {
    localStorage.setItem(`auth_${this.type}`, new Date().getTime().toString());
    this.allService.setCookie(`${this.type}_token`, this.token, {expires: 99999999});
    this.allService.login$.next(this);
  }

  getVarLocal(name: string, defaultValue: any = {}) {
    try {
      return JSON.parse(localStorage.getItem(`${this.type}_` + name + '_' + this.token)) || defaultValue;
    } catch (e) {
      return defaultValue;
    }
  }

  setVarLocal(name: string, val: any): void {
    const key = `${this.type}_` + name + '_' + this.token;
    try {
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) {
      localStorage.removeItem(key);
      console.error('setVarLocal error', key);
    }
  }

  setLocalHistory(id, arHistory: Message[]): void {
    log('setLocalHistory');
    if (!id) {
      return;
    }
    this.arLocalHistory[id] = arHistory;
    // localStorage.setItem('telegram_history', JSON.stringify(this.arLocalHistory));
    this.setVarLocal('history', this.arLocalHistory);
  }

  loadProfile(initiator = 'none'): Observable<any> {
    log('loadProfile', this.type, initiator);
    this.isLoadedProfileError = false;
    this.http.get(`${this.urlApi}/api/telegram/profile?service=${this.type}`, this.httpOptions).pipe(throttleTime(3000)).subscribe(
      (result: any) => {
        this.isLoadedProfileError = false;
        this.arProfile = result;
        this.isLoadedProfile = true;
        this.setVarLocal('profile', this.arProfile);
        // console.log('Loaded profile getProfile')
        this.getProfile$.next(this.arProfile);

      },
      (error) => {
        this.getProfile$.error(error);
        this.isLoadedProfileError = error;
        this.interfaceService.errorHandling(error, true, this);
      }
    );
    // }
    return this.getProfile$;
  }

  getProfile(initiator = ''): Observable<Profile> {
    log('getProfile', this.type, initiator);
    if (this.isLoadedProfile) {
      return new Observable((observer) => {
        setTimeout(() => {
          observer.next(this.arProfile);
          observer.complete();
        });
      });
    } else {
      return this.getProfile$;
    }
  }
  editProfile(data: EditProfile): Observable<Profile> {
    return (this.http.put(`${this.urlApi}/api/telegram/profile?service=${this.type}`, data, this.httpOptions) as any);
  }
  getAvatars(): Observable<{results: Avatar[]}> {
    return (this.http.get(`${this.urlApi}/api/telegram/profile/avatar?service=${this.type}`, this.httpOptions) as any);
  }
  removeAvatar(fileId: string): Observable<any> {
    return (this.http.delete(`${this.urlApi}/api/telegram/profile/avatar/${fileId}?service=${this.type}`,  this.httpOptions) as any);
  }
  checkUsername(username: string) {
    return this.http.get(this.urlApi + `/api/telegram/profile/username/check/${username}`, this.httpOptions);
  }
  setUsername(username: string) {
    return this.http.post(this.urlApi + `/api/telegram/profile/username/`, {
      username
    }, this.httpOptions);
  }
  sendCode(phone: string, arTokens = []) {
    return this.http.get(this.urlApi + `/api/telegram/send_code?phone=${phone}&tokens=` + arTokens.join(','), this.httpOptions);
  }
  resendCode(phone: string, phoneCodeHash: string) {
    return this.http.get(this.urlApi + `/api/telegram/resend_code?phone=${phone}&phone_code_hash=${phoneCodeHash}`, this.httpOptions);
  }
  checkCode(phoneCodeHash: string, code: number, phone: string, arTokens: string[] = [], partnerId = 0) {
    return this.http.post(
      `${this.urlApi}/api/telegram/confirm_code`,
      {
        partner: partnerId,
        phone_code_hash: phoneCodeHash,
        code,
        phone,
        tokens: arTokens.join(',')
      },
      this.httpOptions
    );
  }

  checkPassword(password: string, arTokens: string[] = [], partnerId = 0) {
    return this.http.post(
      `${this.urlApi}/api/telegram/confirm_password`,
      {
        partner: partnerId,
        password,
        tokens: arTokens.join(',')
      },
      this.httpOptions
    );
  }

  forwardMessages(chatId: any, fromChatId: any, messages: Message[]) {
    const messageIds = messages.map((x) => x?.id || x);
    const arData = {
      chat_id: chatId,
      from_chat_id: fromChatId,
      message_ids: messageIds
    };
    return this.http.post(`${this.urlApi}/api/telegram/messages/forward/`, arData, this.httpOptions);
  }

  deleteMessages(chatId: any, revoke = true, messageIds: any) {
    return this.http
      .delete(
        `${this.urlApi}/api/telegram/messages/?body=none&chat_id=${chatId}&revoke=${revoke}&list_of_message_ids=` +
        messageIds.join(','),
        this.httpOptions
      )
      .pipe(); // tag("deleteMessages")
  }

  saveMessage(arMessage: Message) {
    const arData = {
      chat_id: arMessage.chat_id,
      message_id: arMessage.id,
      text: arMessage.text
    };
    return this.http.put(`${this.urlApi}/api/telegram/messages`, arData, this.httpOptions);
  }

  sendMessage(arData: SendMessage): Observable<Message[]> {
    return this.http.post(`${this.urlApi}/api/telegram/messages`, arData, this.httpOptions) as any;
  }

  sendKeyBoard(arData: any) {
    return this.http.post(`${this.urlApi}/api/telegram/messages`, arData, this.httpOptions);
  }

  getDetailInfo(id: any, media = true, membersCount = 0, freeAccount = false): Observable<ResultChatDetail> {
    return this.http.get(`${this.urlApi}/api/telegram/chats/detail/${id}?media=${media}&members_count=${membersCount}&service=${this.type}&free_account=${freeAccount}`, this.httpOptions) as any;
  }

  chatSearch(id: any, filter = '') {
    return this.http.get(`${this.urlApi}/api/telegram/chats/search/${id}`, this.httpOptions);
  }

  getChatSearch(id: any, filter = 'empty', query = '', offset = 0, limit = 15) {
    const get = this.objectToParam({
      filter,
      query,
      offset,
      limit
    });
    return this.http.get(`${this.urlApi}/api/telegram/chats/search/${id}${get}`, this.httpOptions);
  }

  getGlobalSearch(query = '', limit = 15) {
    const get = this.objectToParam({
      query,
      limit
    });
    return this.http.get(`${this.urlApi}/api/telegram/search/global${get}`, this.httpOptions);
  }

  sendVoice(file, chatId): Observable<Message[]> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('chat_id', chatId);
    const httpParams: any = {...this.httpOptionsMulti, ...{}};
    httpParams.observe = 'events';
    return this.http.post(`${this.urlApi}/api/telegram/messages/voice`, formData, httpParams) as any;
  }

  getFile(fileId: string, fileUniqueId: string, ungzip = false): Observable<any> {
    // log('getFile', fileId, ungzip);
    if (!ungzip) {
      return new Observable((observer) => {
        setTimeout(() => {
          this.sendEvent('get_file_' + fileId, {file_id: fileId, file_unique_id: fileUniqueId, token: this.token, ws: true});
        }, 100);

        const subscription = this.wsService.on<IMessage>('get_file_' + fileId).subscribe((data: any) => {
          // console.log('!!!!!!!!!!!!!!!!!! getFile', data);
          subscription.unsubscribe();
          observer.next(data);
          observer.complete();
        });
      });
    } else {
      return this.http.get(
        `${this.urlApi}/api/telegram/file/${fileId}/?file_unique_id=${fileUniqueId}&ungzip=${ungzip}`,
        this.httpOptions
      );
    }
  }

  getStickers() {
    return this.http.get(`${this.urlApi}/api/telegram/stickers?service=${this.type}`, this.httpOptions);
  }

  getGifs() {
    return this.http.get(`${this.urlApi}/api/telegram/messages/gifs?service=${this.type}`, this.httpOptions);
  }

  deleteFile(uri: string) {
    // TODO Не безопасно!!!
    return this.http.delete(`${this.urlApiFileUpload}?uri=${uri}`, this.httpOptions);
  }

  setNotify(arData: any) {
    return this.http.post(`${this.urlApi}/api/telegram/settings/notify/${arData.peer}?service=${this.type}`, arData, this.httpOptions);
  }

  getNotify(peer: string | number, chat: any = {}) {
    return this.http.get(`${this.urlApi}/api/telegram/settings/notify/${peer}?service=${this.type}`, this.httpOptions);
  }

  toggleChatPine(id, pinned: boolean) {
    return this.http.post(
      `${this.urlApi}/api/telegram/chats/${id}/pin`,
      {
        pinned
      },
      this.httpOptions
    );
  }

  readHistory(chatId, maxId: string | number) {
    return this.http.post(
      `${this.urlApi}/api/telegram/chats/${chatId}/read`,
      {
        chat_id: chatId,
        max_id: maxId
      },
      this.httpOptions
    );
  }

  leaveChat(chatId, del) {
    return this.http.post(`${this.urlApi}/api/telegram/chats/${chatId}/leave`, {delete: del}, this.httpOptions);
  }

  getFileSrcSticker(attachment: any) {
    const arData: any = {
      ungzip: true,
      file_unique_id: attachment.file_unique_id,
      token: this.token
    };
    const get = this.objectToParam(arData);
    const src = `${this.urlApi}/api/telegram/sticker/${attachment.file_id}${get}`;
    attachment.file_uri = src;
    return src;
  }
  getFileSrc(attachment: any): string {
    if (!attachment.file_name) {
      console.error('getFileSrc not file_name', attachment.file_name);
    }
    const arData: any = {
      file_unique_id: attachment.file_unique_id,
      file_id: attachment.file_id,
      token: this.token
    };
    const get = this.objectToParam(arData);
    const src = `${this.urlApi}/api/telegram/file/download/${attachment.file_name}${get}`;
    attachment.file_uri = src;
    return src;
  }

  getFile$(fileId: string, fileUniqueId = '', textLog = ''): Observable<any> {
    const key = fileUniqueId;
    return new Observable((observer) => {
      if (this.arFiles[key]) {
        log('!!! Cache: ' + key, textLog);
        setTimeout(() => {
          observer.next({file: this.arFiles[key]});
          observer.complete();
        }, 0);
      } else {
        this.getFile(fileId, fileUniqueId).pipe(timeout(50000)).subscribe(
          (result: any) => {
            this.arFiles[key] = result.file;
            observer.next(result);
            observer.complete();
          },
          (error) => {
            observer.error(error);
            observer.complete();
            // this.errorHandling(error);
          }
        );
      }
    }).pipe(first()); // , tag("getFile$")
  }

  getThumbSrc(attachment): void {
    if (isUndefined(attachment.thumb?.file_uri)) {
      this.getFile$(attachment.thumb.file_id || attachment.file_id, attachment.thumb.file_unique_id).subscribe(
        (result: any) => {
          attachment.thumb.file_uri = result.file;
        }
      );
    }
  }

  /*getThumbSrcLink(attachment): void {
    if (!isUndefined(attachment.thumb) && isUndefined(attachment.thumb.file_uri)) {
      const arData: any = {
        file_unique_id: attachment.thumb?.file_unique_id || attachment.file_unique_id,
        file_id: attachment.thumb.file_id,
        token: this.token
      };
      const get = this.objectToParam(arData);
      const src = `${this.urlApi}/api/telegram/file/download/${attachment.file_name}${get}`;
      attachment.thumb.file_uri = src;
    }
  }*/
  loadAttachment$(attachment): Observable<any> {
    console.log('loadAttachment$ start', attachment);
    return new Observable((observer) => {
      const key = attachment.file_id;
      if (this.arFiles[key]) {
        console.log('loadAttachment$ cache', attachment);
        setTimeout(() => {
          attachment.file_uri = this.arFiles[key];
          observer.next({file: this.arFiles[key]});
          observer.complete();
        }, 1);
      } else {
        console.log('loadAttachment$', attachment);
        this.getFile(attachment.file_id, attachment.file_unique_id).pipe(timeout(50000)).subscribe(
          (result: any) => {
            attachment.file_uri = result.file;
            observer.next(result);
            observer.complete();
          },
          (error) => {
            observer.error(error);
            observer.complete();
            // this.errorHandling(error);
          }
        );
      }
    }).pipe(first()); // , tag("loadAttachment$")
  }

  loadAudio$(attachment): Observable<any> {
    return this.loadAttachment$(attachment);
  }

  contactsList(q = '', online: any = '', count = 100, timeout = 90): Observable<{ results: Chat[] | Contact[] }> {
    return this.http.get(
      this.urlApi + `/api/telegram/contacts?q=${q}&online=${online}&count=${count}&service=${this.type}`,
      this.httpOptions
    ) as any;
  }

  chatList(filterType = '', offsetDate = 0): Observable<{ results: Chat[] }> {
    const get = this.objectToParam({
      filter_type: filterType,
      offset_date: offsetDate,
      service: this.type
    });
    return this.http.get(this.urlApi + `/api/telegram/chats${get}`, this.httpOptions) as any;
  }

  chatNew(title = '', arUsers: any) {
    return this.http.post(
      this.urlApi + `/api/telegram/chats`,
      {
        users: arUsers.join(','),
        title
      },
      this.httpOptions
    );
  }

  getHistory(
    chatId: string | number,
    offsetId: number | string = 0,
    currentCount: number,
    limit = 15,
    cursor: any = {},
    fromMessage: false | string | number = false,
    fromChat: false | string | number = false
  ): Observable<ResultHistory> {
    /*return new Observable((observer) => {
      const key = `get_history_${chatId}_${offsetId}_${limit}`;
      this.sendEvent(key, {chat_id: chatId, offset_id: offsetId, limit});
      const subscribe = this.wsService.on<IMessage>(key).subscribe((data: any) => {
        if (data.error) {
          observer.error(data.error);
        }else{
          observer.next(data);
        }
        subscribe.unsubscribe();
        observer.complete();
      });
    });*/

    const get = this.objectToParam({
      offset_id: offsetId,
      limit,
      service: this.type,
      from_message: fromMessage,
      from_chat: fromChat
    });
    return this.http.get(`${this.urlApi}/api/telegram/chats/${chatId}${get}`, this.httpOptions) as any;
  }

  /*sendReadMaxId(chatId: number, max_id: any) {
    return this.http.put(
      `${this.urlApi}/api/telegram/chats/${chatId}/`,
      {
        max_id: max_id
      },
      this.httpOptions
    );
  }*/


  set openChat(chat: Chat) {
    this.arTyping = [];
    this._openChat = chat;
  }

  get openChat(): Chat {
    return this._openChat;
  }

  get openChatId() {
    return this._openChatId;
  }

  addChatUser(chatId, userId) {
    return this.http.post(
      `${this.urlApi}/api/telegram/chats/${chatId}/user`,
      {
        user_id: userId
      },
      this.httpOptions
    );
  }

  ///////////
  objectToParam(obj: any): string {
    const str =
      '?' +
      Object.keys(obj)
        .reduce((a, k) => {
          a.push(k + '=' + encodeURIComponent(obj[k]));
          return a;
        }, [])
        .join('&');
    return str;
  }

  clearContact(contact: string): string {
    if (typeof contact !== 'string') {
      return contact;
    }
    if (contact.includes('joinchat/')) {
      contact = contact.replace('joinchat/', '+++');
    }
    return contact.replace('@', '').replace('https://t.me/', '').replace('https://t.me/', '').trim();
  }

  sendEvent(event: string, data: any = {}) {
    if (this.wsService.isConnected) {
      this.wsService.send(event, data);
    } else {
      const status$ = this.wsService.status.pipe(filter(v => v)).subscribe((res) => {
        this.wsService.send(event, data);
        status$.unsubscribe();
      });
    }
  }

}
